module.exports = __webpack_public_path__ + "static/2021-3-新井貴久-6660b2abfa3763d7f24bcf0a51fad69b.jpg";